import {tokensForThemeProvider} from '@forecast-it/design-system';

// A task with Ready output is tinted so it's findable in a long list; once read, the row returns
// to the ordinary background. Shared by every row-rendering surface that implements this tint
// (task-table-v3's row cluster, task-row-v2's row) so a retint only needs one edit.
// Optional chaining because this module loads transitively through the shared web-components
// barrel — unrelated test files that mock '@forecast-it/design-system' without providing
// tokensForThemeProvider would otherwise crash on import alone, before any test even runs.
export const NOVA_UNREAD_HIGHLIGHT = tokensForThemeProvider?.sky?.ref?.color?.green?.['50'];

// Sized for the widest control state - Working's pill (spinner + text) plus its separate stop
// button, ~130px measured live - with a little breathing room for translated text running longer
// than the English default. Not the pill's full original 188px, which left a visible dead gap
// before the next column. Shared so the row cell and its header cell (and, on task-table-v3, the
// table's own width budget) can't drift out of sync with each other.
export const NOVA_INVOCATION_COLUMN_WIDTH = 150;
